import { HighlighterIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Marker = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <HighlighterIcon {...rest} size={Sizes[size]} color={fill} />;
};

Marker.displayName = 'Marker';
